/**
 * RPC Priority Tier Base Constants
 *
 * These are the five tier bases for the dual-pool RPC concurrency limiter.
 * Sub-priorities (local offsets) are defined at the call site — not here.
 *
 * Tiers (highest wins):
 *   Active tab — stream content   : 2000–2999
 *   Active tab — workspace utils  : 1500–1999
 *   Non-active tab — stream       : 1000–1499
 *   Non-active tab — workspace    : 500–999
 *   Global / admin / one-shot     : 0–499
 */

export const RPC_TIER_ACTIVE_STREAM      = 2000;
export const RPC_TIER_ACTIVE_WORKSPACE   = 1500;
export const RPC_TIER_INACTIVE_STREAM    = 1000;
export const RPC_TIER_INACTIVE_WORKSPACE = 500;
export const RPC_TIER_GLOBAL             = 0;
